import "./style.scss";
import { useState } from "react";
import CloseSvg from "@/src/svg/CustomUtils/CloseSvg";
import BtnDefault from "@/src/components/BtnDefault/BtnDefault";

type Props = {
  title: string;
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
};

const DefaultInputChange = ({ title, value, onChange, onClose }: Props) => {
  const [inputValue, setInputValue] = useState<string>(value);

  const handleClear = () => {
    setInputValue("");
  };

  const handleDone = () => {
    onChange(inputValue);
    onClose();
  };

  return (
    <div className="default-input-change">
      <div className="default-input-change-title">
        <div className="default-input-change-title-text">
          <p>{title}</p>
        </div>
        <div className="default-input-change-title-close" onClick={onClose}>
          <CloseSvg />
        </div>
      </div>
      <div className="default-input-change-input">
        <input type="text" value={inputValue} onChange={(e) => setInputValue(e.target.value)} placeholder={title} />
      </div>
      <div className="default-input-change-buttons">
        <BtnDefault onClick={handleClear}>
          <p>Clear</p>
        </BtnDefault>
        <BtnDefault onClick={handleDone} disabled={!inputValue.trim()}>
          <p>Done</p>
        </BtnDefault>
      </div>
    </div>
  );
};

export default DefaultInputChange;
